export interface LoginPayload {
  email: string;
  password: string;
}

export type UserRoleCode =
  | "SUPER_ADMIN"
  | "ADMIN"
  | "DIRECTEUR"
  | "REPRESENTANT_HARAS_REGIONAL"
  | "CHEF_BUREAU"
  | "VETERINAIRE"
  | "SIGNALEUR_AGREE"
  | "RESPONSABLE_HARAS"
  | "ETALONNIER"
  | "NAISSEUR"
  | "PROPRIETAIRE"
  | "UTILISATEUR";

export type PermissionCode =
  | "view_horse" | "view_horse_identification"
  | "create_horse" | "update_horse" | "delete_horse"
  | "view_declaration" | "create_declaration" | "validate_declaration" | "cancel_declaration"
  | "view_document" | "generate_document" | "sign_document" | "generate_certificate"
  | "create_signalment" | "validate_signalment"
  | "signaleur_agree_create" | "signaleur_agree_validate"
  | "manage_stallion" | "manage_mare" | "manage_haras"
  | "record_covering" | "record_birth"
  | "demande_agrement_create" | "demande_agrement_view" | "demande_agrement_validate" | "demande_agrement_delegate"
  | "view_report" | "generate_report" | "export_data"
  | "view_user" | "create_user" | "update_user" | "delete_user" | "assign_role"
  | "manage_role" | "manage_permission" | "manage_settings" | "view_audit_log";

export interface UserPermission {
  id: number;
  code: PermissionCode;
  libelle: string;
  categorie: string;
  description: string;
}

export interface UserRole {
  id: number;
  code: UserRoleCode;
  libelle: string;
  niveau: number;
  description: string;
  permissions: UserPermission[];
}

export interface AuthVeterinaire {
  id: number;
  nom: string;
  prenom: string;
  sexe?: string;
  email?: string;
  telephone?: string;
  telephone2?: string | null;
  numero_permis?: string;
  numero_agrement?: string;
  date_agrement?: string;
  date_expiration_agrement?: string | null;
  specialite?: string | null;
  est_actif?: boolean;
  agrement_valide?: boolean;
}

export interface AuthUser {
  id: number;
  name: string;
  email: string;
  telephone?: string;
  est_actif?: boolean;
  roles: UserRole[];
  veterinaire?: AuthVeterinaire | null;
  haras_id?: number;
  haras?: {
    id: number;
    nom: string;
    code?: string | null;
    numero_unique?: string | null;
    commune_id?: number;
    telephone?: string;
    email?: string;
    adresse?: string;
    type_haras?: string;
    commune?: { id: number; libelle: string };
    departement?: { id: number; libelle: string };
    region?: { id: number; libelle: string };
  };
}

export interface AuthResponse {
  message: string;
  token: string;
  user: AuthUser;
}

// Redirection par rôle (rôle le plus prioritaire = niveau le plus bas)
export const ROLE_REDIRECTS: Record<UserRoleCode, string> = {
  SUPER_ADMIN:       "/malaw/dashboard",
  ADMIN:             "/malaw/dashboard",
  DIRECTEUR:         "/malaw/dashboard",
  REPRESENTANT_HARAS_REGIONAL: "/malaw/dashboard",
  CHEF_BUREAU:       "/malaw/dashboard",
  VETERINAIRE:       "/malaw/dashboard",
  SIGNALEUR_AGREE:   "/malaw/dashboard",
  RESPONSABLE_HARAS: "/malaw/dashboard",
  ETALONNIER:        "/malaw/dashboard",
  NAISSEUR:          "/malaw/dashboard",
  PROPRIETAIRE:      "/malaw/dashboard",
  UTILISATEUR:       "/malaw/dashboard",
};
